<template>
    <div class="dispatch-orders-page">
        <div class="dispatch-orders-filters">
          <div class="filterLocation">
            <el-button type="default" class="filter-btn" @click="openFiltersModal">
              <img src="/static/img/icons/filter.png">
            </el-button>
          </div>
          <div class="dispatch-orders-filters-body">
            <template v-if="hasActiveFilters">
              <div class="filters-header" @click="toggleFiltersCollapse">
                <button class="collapse-toggle-btn" type="button">
                  <i :class="showFiltersCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-down'"></i>
                </button>
                <span class="filters-label">{{$t('orders.filtersApplied')}}:</span>
                <a href="#" @click.prevent.stop="resetFilters()" class="reset-filters-link">{{$t('orders.resetFilters')}}</a>
              </div>
              <div v-show="!showFiltersCollapsed" class="filters-list">
                <span
                  v-for="(sts, key) in requestFilters[0].value"
                  :key="'status-filter-' + sts + '-' + key"
                  class="filter-selection">
                  {{formatLabelFirstLetter('ordersStatus.' + sts)}}
                  <a title="Remove filter" href="#" @click.prevent="removeStatusFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                </span>
                <span
                  v-for="(locId, key) in locationFilter"
                  :key="'location-filter-' + locId + '-' + key"
                  class="filter-selection">
                  {{getLocationName(locId)}}
                  <a title="Remove filter" href="#" @click.prevent="removeLocationFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                </span>
                <template v-if="orderFilters.pickupDatetime && orderFilters.pickupDatetime.length === 2">
                  <span class="filter-selection">Pickup: {{formatDateRange(orderFilters.pickupDatetime)}} <a title="Remove filter" href="#" @click.prevent="removePickupDatetimeFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                </template>
                <template v-if="orderFilters.placedDatetime && orderFilters.placedDatetime.length === 2">
                  <span class="filter-selection">Placed: {{formatDateRange(orderFilters.placedDatetime)}} <a title="Remove filter" href="#" @click.prevent="removePlacedDatetimeFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                </template>
                <template v-if="orderFilters.orderId">
                  <span class="filter-selection">Order ID: {{orderFilters.orderId}} <a title="Remove filter" href="#" @click.prevent="removeOrderIdFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                </template>
                <template v-if="orderFilters.orderNumber">
                  <span class="filter-selection">Order #: {{orderFilters.orderNumber}} <a title="Remove filter" href="#" @click.prevent="removeOrderNumberFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                </template>
                <template v-if="normalizeOrderTotal(orderFilters.orderTotalMin) !== null || normalizeOrderTotal(orderFilters.orderTotalMax) !== null">
                  <span class="filter-selection">Total: {{orderFilters.orderTotalMin || '0'}} - {{orderFilters.orderTotalMax || '∞'}} <a title="Remove filter" href="#" @click.prevent="removeOrderTotalFilter()"><i class="text-warning el-icon-circle-close-outline"></i></a></span>
                </template>
                <template v-if="orderFilters.operator && orderFilters.operator.length > 0">
                  <span
                    v-for="(opId, key) in orderFilters.operator"
                    :key="'operator-filter-' + opId + '-' + key"
                    class="filter-selection">
                    Operator: {{getOperatorName(opId)}}
                    <a title="Remove filter" href="#" @click.prevent="removeOperatorFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                  </span>
                </template>
                <template v-if="orderFilters.paymentType && orderFilters.paymentType.length > 0">
                  <span
                    v-for="(pt, key) in orderFilters.paymentType"
                    :key="'payment-type-filter-' + pt + '-' + key"
                    class="filter-selection">
                    Payment: {{formatLabelFirstLetter('paymentTypes.' + pt)}}
                    <a title="Remove filter" href="#" @click.prevent="removePaymentTypeFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                  </span>
                </template>
                <template v-if="orderFilters.deliveryType && orderFilters.deliveryType.length > 0">
                  <span
                    v-for="(dt, key) in orderFilters.deliveryType"
                    :key="'delivery-type-filter-' + dt + '-' + key"
                    class="filter-selection">
                    {{$t('settingCompany.deliveryType')}}: {{formatLabelFirstLetter('deliveryTypes.' + dt)}}
                    <a title="Remove filter" href="#" @click.prevent="removeDeliveryTypeFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                  </span>
                </template>
                <template v-if="orderFilters.source && orderFilters.source.length > 0">
                  <span
                    v-for="(src, key) in orderFilters.source"
                    :key="'source-filter-' + src + '-' + key"
                    class="filter-selection">
                    Source: {{formatLabelFirstLetter('ordersSource.' + src)}}
                    <a title="Remove filter" href="#" @click.prevent="removeSourceFilter(key)"><i class="text-warning el-icon-circle-close-outline"></i></a>
                  </span>
                </template>
              </div>
            </template>
            <template v-else>
              <span class="no-filters-label">{{$t('orders.noFiltersApplied')}}</span>
            </template>
          </div>
        </div>

        <div class="canvaOrders">
            <!-- New Orders Column -->
            <div class="col-order new">
              <p>{{ $t('ordersStatus.NEW') }} <span>{{ ordersCount.new }}</span></p>
              <template v-if="orders.new && orders.new.length > 0">
                <div v-for="order in orders.new" :key="order.id" class="order-card">
                  <div class="order-top">
                    <div class="örderId" @click="goToOrder(order.id)">
                      <p>{{ $t('reports.order') }} #{{ order.number }}</p>
                    </div>
                    <div class="orderDate">
                      <img
                        src="/static/img/icon-calendar.png"
                        alt="Date Icon"
                      />
                      <span>{{ order.pickup_datetime }}</span>
                    </div>
                  </div>
                  <div class="ord-client">
                    <div class="client">
                      <span><b>{{order.delivery_details_firstname}}</b></span>
                      <span class="phone">{{order.delivery_details_phone}}</span>
                      <div class="address">
                        <div class="address_shipping" v-if="order && order.address_shipping">
                          <span>
                            <img src="/static/img/icon-location.png">
                            {{order.address_shipping.street}} {{order.address_shipping.number}}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="address">
                      <div class="production_details" v-if="order.production_details && order.production_details.location">
                        <span>
                          <b>{{$t('orders.ordLocation')}}:</b>
                          {{order.production_details.location.name}}
                        </span>
                        <span v-if="order && order.shipping_details" class="zone">
                          <b>{{$t('orders.zone')}}:</b>
                          {{order.shipping_details.name}}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="footer">
                    <div class="total">
                      <span>{{order.totals_grandtotal}} {{order.currency}} ({{order.payment_type}})</span>
                    </div>
                    <div class="method">
                      <div class="type">{{formatDeliveryType(order.delivery_type)}}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="no-orders">
                  <img src="/static/img/no-orders.png">
                </div>
              </template>
            </div>

            <!-- Processing Orders Column -->
            <div class="col-order processing">
              <p>{{ $t('ordersStatus.PROCESSING') }} <span>{{ ordersCount.processing }}</span></p>
              <template v-if="orders.processing && orders.processing.length > 0">
                <div v-for="order in orders.processing" :key="order.id" class="order-card">
                  <div class="order-top">
                    <div class="örderId" @click="goToOrder(order.id)">
                      <p>{{ $t('reports.order') }} #{{ order.number }}</p>
                    </div>
                    <div class="orderDate">
                      <img
                        src="/static/img/icon-calendar.png"
                        alt="Date Icon"
                      />
                      <span>{{ order.pickup_datetime }}</span>
                    </div>
                  </div>
                  <div class="ord-client">
                    <div class="client">
                      <span><b>{{order.delivery_details_firstname}}</b></span>
                      <span class="phone">{{order.delivery_details_phone}}</span>
                    </div>
                    <div class="address">
                      <div class="address_shipping" v-if="order && order.address_shipping">
                        <span>
                          <img src="/static/img/icon-location.png">
                          {{order.address_shipping.street}} {{order.address_shipping.number}}
                        </span>
                      </div>
                      <div class="production_details" v-if="order.production_details && order.production_details.location">
                        <span>
                          <b>{{$t('orders.ordLocation')}}:</b>
                          {{order.production_details.location.name}}
                        </span>
                        <span v-if="order && order.shipping_details" class="zone">
                          <b>{{$t('orders.zone')}}:</b>
                          {{order.shipping_details.name}}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="footer">
                    <div class="total">
                      <span>{{order.totals_grandtotal}} {{order.currency}} ({{order.payment_type}})</span>
                    </div>
                    <div class="method">
                      <div class="type">{{formatDeliveryType(order.delivery_type)}}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="no-orders">
                  <img src="/static/img/no-orders.png">
                </div>
              </template>
            </div>

            <!-- Prepared Orders Column -->
            <div class="col-order prepared">
              <p>{{ $t('ordersStatus.PREPARED') }} <span>{{ ordersCount.prepared }}</span></p>
              <template v-if="orders.prepared && orders.prepared.length > 0">
                <div v-for="order in orders.prepared" :key="order.id" class="order-card">
                  <div class="order-top">
                    <div class="örderId" @click="goToOrder(order.id)">
                      <p>{{ $t('reports.order') }} #{{ order.number }}</p>
                    </div>
                    <div class="orderDate">
                      <img
                        src="/static/img/icon-calendar.png"
                        alt="Date Icon"
                      />
                      <span>{{ order.pickup_datetime }}</span>
                    </div>
                  </div>
                  <div class="ord-client">
                    <div class="client">
                      <span><b>{{order.delivery_details_firstname}}</b></span>
                      <span class="phone">{{order.delivery_details_phone}}</span>
                    </div>
                    <div class="address">
                      <div class="address_shipping" v-if="order && order.address_shipping">
                        <span>
                          <img src="/static/img/icon-location.png">
                          {{order.address_shipping.street}} {{order.address_shipping.number}}
                        </span>
                      </div>
                      <div class="production_details" v-if="order.production_details && order.production_details.location">
                        <span>
                          <b>{{$t('orders.ordLocation')}}:</b>
                          {{order.production_details.location.name}}
                        </span>
                        <span v-if="order && order.shipping_details" class="zone">
                          <b>{{$t('orders.zone')}}:</b>
                          {{order.shipping_details.name}}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="footer">
                    <div class="total">
                      <span>{{order.totals_grandtotal}} {{order.currency}} ({{order.payment_type}})</span>
                    </div>
                    <div class="method">
                      <div class="type">{{formatDeliveryType(order.delivery_type)}}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="no-orders">
                  <img src="/static/img/no-orders.png">
                </div>
              </template>
            </div>

            <!-- Transport Orders Column -->
            <div class="col-order transport">
              <p>{{ $t('ordersStatus.TRANSPORT') }} <span>{{ ordersCount.transport }}</span></p>
              <template v-if="orders.transport && orders.transport.length > 0">
                <div v-for="order in orders.transport" :key="order.id" class="order-card">
                  <div class="order-top">
                    <div class="örderId" @click="goToOrder(order.id)">
                      <p>{{ $t('reports.order') }} #{{ order.number }}</p>
                    </div>
                    <div class="orderDate">
                      <img
                        src="/static/img/icon-calendar.png"
                        alt="Date Icon"
                      />
                      <span>{{ order.pickup_datetime }}</span>
                    </div>
                  </div>
                  <div class="ord-client">
                    <div class="client">
                      <span><b>{{order.delivery_details_firstname}}</b></span>
                      <span class="phone">{{order.delivery_details_phone}}</span>
                    </div>
                    <div class="address">
                      <div class="address_shipping" v-if="order && order.address_shipping">
                        <span>
                          <img src="/static/img/icon-location.png">
                          {{order.address_shipping.street}} {{order.address_shipping.number}}
                        </span>
                      </div>
                      <div class="production_details" v-if="order.production_details && order.production_details.location">
                        <span>
                          <b>{{$t('orders.ordLocation')}}:</b>
                          {{order.production_details.location.name}}
                        </span>
                        <span v-if="order && order.shipping_details" class="zone">
                          <b>{{$t('orders.zone')}}:</b>
                          {{order.shipping_details.name}}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="footer">
                    <div class="total">
                      <span>{{order.totals_grandtotal}} {{order.currency}} ({{order.payment_type}})</span>
                    </div>
                    <div class="method">
                      <div class="type">{{formatDeliveryType(order.delivery_type)}}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="no-orders">
                  <img src="/static/img/no-orders.png">
                </div>
              </template>
            </div>

            <!-- Delivered Orders Column -->
            <div class="col-order delivered">
              <p>{{ $t('ordersStatus.DELIVERED') }} <span>{{ ordersCount.delivered }}</span></p>
              <template v-if="orders.delivered && orders.delivered.length > 0">
                <div v-for="order in orders.delivered" :key="order.id" class="order-card">
                  <div class="order-top">
                    <div class="örderId" @click="goToOrder(order.id)">
                      <p>{{ $t('reports.order') }} #{{ order.number }}</p>
                    </div>
                    <div class="orderDate">
                      <img
                        src="/static/img/icon-calendar.png"
                        alt="Date Icon"
                      />
                      <span>{{ order.pickup_datetime }}</span>
                    </div>
                  </div>
                  <div class="ord-client">
                    <div class="client">
                      <span><b>{{order.delivery_details_firstname}}</b></span>
                      <span class="phone">{{order.delivery_details_phone}}</span>
                    </div>
                    <div class="address">
                      <div class="address_shipping" v-if="order && order.address_shipping">
                        <span>
                          <img src="/static/img/icon-location.png">
                          {{order.address_shipping.street}} {{order.address_shipping.number}}
                        </span>
                      </div>
                      <div class="production_details" v-if="order.production_details && order.production_details.location">
                        <span>
                          <b>{{$t('orders.ordLocation')}}:</b>
                          {{order.production_details.location.name}}
                        </span>
                        <span v-if="order && order.shipping_details" class="zone">
                          <b>{{$t('orders.zone')}}:</b>
                          {{order.shipping_details.name}}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="footer">
                    <div class="total">
                      <span>{{order.totals_grandtotal}} {{order.currency}} ({{order.payment_type}})</span>
                    </div>
                    <div class="method">
                      <div class="type">{{formatDeliveryType(order.delivery_type)}}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="no-orders">
                  <img src="/static/img/no-orders.png">
                </div>
              </template>
            </div>

            <!-- Canceled Orders Column -->
            <div class="col-order canceled">
              <p>{{ $t('ordersStatus.CANCELED') }} <span>{{ ordersCount.canceled }}</span></p>
              <template v-if="orders.canceled && orders.canceled.length > 0">
                <div v-for="order in orders.canceled" :key="order.id" class="order-card">
                  <div class="order-top">
                    <div class="örderId" @click="goToOrder(order.id)">
                      <p>{{ $t('reports.order') }} #{{ order.number }}</p>
                    </div>
                    <div class="orderDate">
                      <img
                        src="/static/img/icon-calendar.png"
                        alt="Date Icon"
                      />
                      <span>{{ order.pickup_datetime }}</span>
                    </div>
                  </div>
                  <div class="ord-client">
                    <div class="client">
                      <span><b>{{order.delivery_details_firstname}}</b></span>
                      <span class="phone">{{order.delivery_details_phone}}</span>
                    </div>
                    <div class="address">
                      <div class="address_shipping" v-if="order && order.address_shipping">
                        <span>
                          <img src="/static/img/icon-location.png">
                          {{order.address_shipping.street}} {{order.address_shipping.number}}
                        </span>
                      </div>
                      <div class="production_details" v-if="order.production_details && order.production_details.location">
                        <span>
                          <b>{{$t('orders.ordLocation')}}:</b>
                          {{order.production_details.location.name}}
                        </span>
                        <span v-if="order && order.shipping_details" class="zone">
                          <b>{{$t('orders.zone')}}:</b>
                          {{order.shipping_details.name}}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="footer">
                    <div class="total">
                      <span>{{order.totals_grandtotal}} {{order.currency}} ({{order.payment_type}})</span>
                    </div>
                    <div class="method">
                      <div class="type">{{formatDeliveryType(order.delivery_type)}}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="no-orders">
                  <img src="/static/img/no-orders.png">
                </div>
              </template>
            </div>
        </div>

        <vmodal name="dispatchOrdersFiltersModal" height="auto" width="1200" :adaptive="true" :scrollable="true" class="filtersAndSortModal dispatch-filters-modal">
          <div class="card">
            <div class="card-content">
              <div class="modal-header slim-header">
                <h4>{{$t('orders.filtersAndSort')}}</h4>
              </div>
              <div class="modal-body slim-body">
                <div class="filters-grid">
                  <div class="modal-column-left">
                    <h6 class="section-title">{{$t('orders.filters')}}</h6>

                    <div class="filter-section">
                      <h6>{{$t('orders.status')}}</h6>
                      <div class="button-group-wrap status-filter-buttons">
                        <button
                          v-for="key in filteredStatuses"
                          :key="key"
                          :class="'btn btn-status-filter ' + (modalRequestFilters[0].value.includes(key) ? 'btn-' + orderStatusClass(key) + ' current ' + key : 'btn-default')"
                          @click="toggleModalStatusFilter(key)">
                          {{formatLabelFirstLetter('ordersStatus.' + key)}}
                        </button>
                      </div>
                    </div>

                    <div class="filter-section">
                      <h6>{{$t('settingCompany.deliveryType')}}</h6>
                      <div class="button-group-wrap status-filter-buttons delivery-type-buttons">
                        <button
                          v-for="dt in deliveryTypeOptions"
                          :key="dt"
                          :class="'btn btn-status-filter ' + (modalOrderFilters.deliveryType && modalOrderFilters.deliveryType.includes(dt) ? 'btn-primary current ' + dt : 'btn-default')"
                          @click="toggleModalDeliveryTypeFilter(dt)">
                          {{formatLabelFirstLetter('deliveryTypes.' + dt)}}
                        </button>
                      </div>
                    </div>

                    <div class="filter-section">
                      <h6>{{$t('orders.source')}}</h6>
                      <div class="button-group-wrap status-filter-buttons source-filter-buttons">
                        <button
                          v-for="src in sourceOptions"
                          :key="src"
                          :class="'btn btn-status-filter ' + (modalOrderFilters.source && modalOrderFilters.source.includes(src) ? 'btn-primary current ' + src : 'btn-default')"
                          @click="toggleModalSourceFilter(src)">
                          {{formatLabelFirstLetter('ordersSource.' + src)}}
                        </button>
                      </div>
                    </div>

                    <div class="filter-section">
                      <h6>{{$t('orders.payment')}}</h6>
                      <div class="button-group-wrap status-filter-buttons payment-type-buttons">
                        <button
                          v-for="pt in paymentTypeOptions"
                          :key="pt"
                          :class="'btn btn-status-filter ' + (modalOrderFilters.paymentType && modalOrderFilters.paymentType.includes(pt) ? 'btn-primary current ' + pt : 'btn-default')"
                          @click="toggleModalPaymentTypeFilter(pt)">
                          {{formatLabelFirstLetter('paymentTypes.' + pt)}}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="modal-column-right">
                    <div class="filter-section">
                      <h6>{{$t('orders.pickupDatetime')}}</h6>
                      <el-date-picker
                        type="datetimerange"
                        v-model="modalOrderFilters.pickupDatetime"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :placeholder="$t('orders.selectDateRange')"
                        @change="adjustDatetimeRange('pickupDatetime')"
                        style="width: 100%;">
                      </el-date-picker>
                    </div>

                    <div class="filter-section">
                      <h6>{{$t('orders.placedDatetime')}}</h6>
                      <el-date-picker
                        type="datetimerange"
                        v-model="modalOrderFilters.placedDatetime"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :placeholder="$t('orders.selectDateRange')"
                        @change="adjustDatetimeRange('placedDatetime')"
                        style="width: 100%;">
                      </el-date-picker>
                    </div>

                    <div class="filter-section">
                      <h6>{{$t('orders.location')}}</h6>
                      <el-select
                        v-model="modalLocationFilter"
                        multiple
                        clearable
                        filterable
                        collapse-tags
                        class="w-100"
                        style="width: 100%;"
                        :placeholder="$t('orders.location')">
                        <el-option
                          v-for="loc in locations"
                          :key="'modal-location-' + loc.id"
                          :label="loc.name"
                          :value="getLocationFilterValue(loc)">
                        </el-option>
                      </el-select>
                    </div>

                    <div class="filter-section">
                      <h6>{{$t('orders.orderId')}}</h6>
                      <el-input
                        v-model="modalOrderFilters.orderId"
                        :placeholder="$t('orders.enterOrderId')">
                      </el-input>
                    </div>

                    <div class="filter-section">
                      <h6>{{$t('orders.orderNumber')}}</h6>
                      <el-input
                        v-model="modalOrderFilters.orderNumber"
                        :placeholder="$t('orders.enterOrderNumber')">
                      </el-input>
                    </div>

                    <div class="filter-section">
                      <h6>{{$t('orders.operator')}}</h6>
                      <el-select
                        v-model="modalOrderFilters.operator"
                        multiple
                        clearable
                        filterable
                        collapse-tags
                        class="w-100"
                        style="width: 100%;"
                        :placeholder="$t('reports.operator')">
                        <el-option
                          v-for="op in operatorOptions"
                          :key="'op-' + op.id"
                          :label="op.label"
                          :value="op.id">
                        </el-option>
                      </el-select>
                    </div>

                    <div class="filter-section">
                      <h6>{{$t('orders.orderTotal')}}</h6>
                      <div class="range-row">
                        <el-input-number
                          v-model="modalOrderFilters.orderTotalMin"
                          :placeholder="$t('orders.min')"
                          :precision="2"
                          :controls="false"
                          style="flex: 1; line-height: 44px;">
                        </el-input-number>
                        <span>-</span>
                        <el-input-number
                          v-model="modalOrderFilters.orderTotalMax"
                          :placeholder="$t('orders.max')"
                          :precision="2"
                          :controls="false"
                          style="flex: 1; line-height: 44px;">
                        </el-input-number>
                      </div>
                    </div>

                    <div class="filter-section">
                      <h6>{{$t('general.sortOrder')}}</h6>
                      <el-radio-group v-model="modalSortOrder">
                        <el-radio
                          v-for="sort in sortOptions"
                          :key="'sort-' + sort.id"
                          :label="sort.id"
                          style="display: block; margin-bottom: 10px;">
                          {{$t('general.sort' + sort.name)}}
                        </el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                </div>

                <div class="modal-footer slim-footer">
                  <el-button type="default" size="small" @click="resetModalFilters">{{$t('general.reset')}}</el-button>
                  <el-button type="primary" size="small" @click="applyFilters">{{$t('general.apply')}}</el-button>
                </div>
              </div>
            </div>
          </div>
        </vmodal>
    </div>
</template>

<script>
  import Vue from 'vue'
  import {Input, Select, Option, DatePicker, Button, InputNumber, Radio, RadioGroup} from 'element-ui'
  import vmodal from 'vue-js-modal'

  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DatePicker)
  Vue.use(Button)
  Vue.use(InputNumber)
  Vue.use(Radio)
  Vue.use(RadioGroup)
  Vue.use(vmodal, { componentName: 'vmodal' })

  const DEFAULT_STATUSES = ['NEW', 'PROCESSING', 'PREPARED', 'TRANSPORT', 'DELIVERED', 'CANCELED']

  export default {
    computed: {
      hasActiveFilters () {
        const hasStatusFilters = this.requestFilters[0].value && this.requestFilters[0].value.length > 0
        const hasLocationFilters = this.locationFilter.length > 0
        const hasPickupDatetime = this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2
        const hasPlacedDatetime = this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2
        const hasOrderId = this.orderFilters.orderId && String(this.orderFilters.orderId).trim() !== ''
        const hasOrderNumber = this.orderFilters.orderNumber && this.orderFilters.orderNumber.trim() !== ''
        const hasOrderTotal = this.normalizeOrderTotal(this.orderFilters.orderTotalMin) !== null || this.normalizeOrderTotal(this.orderFilters.orderTotalMax) !== null
        const hasOperator = this.orderFilters.operator && this.orderFilters.operator.length > 0
        const hasPaymentType = this.orderFilters.paymentType && this.orderFilters.paymentType.length > 0
        const hasDeliveryType = this.orderFilters.deliveryType && this.orderFilters.deliveryType.length > 0
        const hasSource = this.orderFilters.source && this.orderFilters.source.length > 0

        return hasStatusFilters || hasLocationFilters || hasPickupDatetime || hasPlacedDatetime ||
               hasOrderId || hasOrderNumber || hasOrderTotal || hasOperator || hasPaymentType || hasDeliveryType || hasSource
      },
      filteredStatuses () {
        return Object.keys(this.statuses).filter(key => key !== 'DRAFT')
      }
    },
    data () {
      return {
        drivers: [],
        orders: {
          new: [],
          processing: [],
          prepared: [],
          transport: [],
          delivered: [],
          canceled: []
        },
        ordersCount: {
          new: 0,
          processing: 0,
          prepared: 0,
          transport: 0,
          delivered: 0,
          canceled: 0
        },
        loading: false,
        showFiltersCollapsed: false,
        modalOrderFilters: {
          pickupDatetime: null,
          placedDatetime: null,
          orderId: '',
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: [],
          source: []
        },
        modalLocationFilter: [],
        modalSortOrder: 1,
        modalRequestFilters: [{value: DEFAULT_STATUSES.slice()}],
        requestFilters: [{value: DEFAULT_STATUSES.slice()}],
        locationFilter: [],
        sortOrder: 1,
        operatorOptions: [],
        sourceOptions: [1, 2, 3, 4, 5, 6, 7, 8],
        paymentTypeOptions: ['CASH', 'CARD', 'POS', 'CARD_POS', 'CASH_MACHINE', 'POS_KIOSK', 'ONLINE', 'SPLIT', 'ROOM', 'FOLIO', 'EVENT', 'MANCARE_PERSONAL', 'PROTOCOL', 'VIRAMENT', 'GLOVO_CARD', 'GLOVO_CASH', 'BOLT_CASH', 'BOLT_CARD', 'WOLT_CASH', 'WOLT_CARD', 'null'],
        deliveryTypeOptions: ['PICK_UP', 'DELIVERY', 'EAT_LOCATION', 'MEET_HALF', 'SELF_ORDERING'],
        orderFilters: {
          pickupDatetime: null,
          placedDatetime: null,
          orderId: '',
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: [],
          source: []
        },
        sortOptions: [
          { id: 1, name: 'CreatedDescending' },
          { id: 2, name: 'CreatedAscending' },
          { id: 3, name: 'PickupDescending' },
          { id: 4, name: 'PickupAscending' }
        ],
        resetFiltersObj: [{value: DEFAULT_STATUSES.slice()}],
        statuses: this.$session.get('defaultData')['order_statuses']['ALL_DELIVERY_TYPES'],
        locations: []
      }
    },
    created () {
      this.loadSavedFilters()
      this.getPosUsers()
      this.getLocations().then(() => {
        this.getDispatchOrders()
      }).catch(() => {
        this.getDispatchOrders()
      })
    },
    methods: {
      emptyOrdersBuckets () {
        return {
          new: [],
          processing: [],
          prepared: [],
          transport: [],
          delivered: [],
          canceled: []
        }
      },
      emptyOrdersCount () {
        return {
          new: 0,
          processing: 0,
          prepared: 0,
          transport: 0,
          delivered: 0,
          canceled: 0
        }
      },
      buildFilterParams () {
        const data = {}

        // Always send statuses (including defaults) so the request matches the UI
        data.statuses = (this.requestFilters[0].value && this.requestFilters[0].value.length)
          ? this.requestFilters[0].value.join(',')
          : DEFAULT_STATUSES.join(',')

        if (this.locationFilter.length) {
          const normalizedIds = this.locationFilter.map(id => parseInt(id, 10)).filter(id => !isNaN(id))
          data.locations = normalizedIds.join(',')
        }

        const sortOrderId = this.sortOrder || 1
        const sortOption = this.sortOptions.find(sort => sort.id === parseInt(sortOrderId))
        // Always send sort (default CreatedDescending)
        data.sort_order = sortOption ? sortOption.name : 'CreatedDescending'

        if (this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2) {
          data.pickup_datetime_from = this.orderFilters.pickupDatetime[0]
          data.pickup_datetime_to = this.adjustEndTime(this.orderFilters.pickupDatetime[1])
        }
        if (this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2) {
          data.created_at_from = this.orderFilters.placedDatetime[0]
          data.created_at_to = this.adjustEndTime(this.orderFilters.placedDatetime[1])
        }
        if (this.orderFilters.orderId && String(this.orderFilters.orderId).trim() !== '') {
          data.id = String(this.orderFilters.orderId).trim()
        }
        if (this.orderFilters.orderNumber && this.orderFilters.orderNumber.trim() !== '') {
          data.order_number = this.orderFilters.orderNumber.trim()
        }
        if (this.normalizeOrderTotal(this.orderFilters.orderTotalMin) !== null) {
          data.order_total_min = this.normalizeOrderTotal(this.orderFilters.orderTotalMin)
        }
        if (this.normalizeOrderTotal(this.orderFilters.orderTotalMax) !== null) {
          data.order_total_max = this.normalizeOrderTotal(this.orderFilters.orderTotalMax)
        }
        if (this.orderFilters.operator && this.orderFilters.operator.length > 0) {
          data.operator = this.orderFilters.operator.join(',')
        }
        if (this.orderFilters.paymentType && this.orderFilters.paymentType.length > 0) {
          data.payment_type = this.orderFilters.paymentType.join(',')
        }
        if (this.orderFilters.deliveryType && this.orderFilters.deliveryType.length > 0) {
          data.delivery_type = this.orderFilters.deliveryType.join(',')
        }
        if (this.orderFilters.source && this.orderFilters.source.length > 0) {
          data.source = this.orderFilters.source.join(',')
        }

        return data
      },
      orderMatchesClientFilters (order) {
        const status = this.getOrderStatus(order)
        if (this.requestFilters[0].value.length && status && this.requestFilters[0].value.indexOf(status) === -1) {
          return false
        }
        if (this.orderFilters.deliveryType && this.orderFilters.deliveryType.length > 0) {
          if (this.orderFilters.deliveryType.indexOf(order.delivery_type) === -1) {
            return false
          }
        }
        if (this.orderFilters.paymentType && this.orderFilters.paymentType.length > 0) {
          const payment = order.payment_type == null ? 'null' : String(order.payment_type)
          if (this.orderFilters.paymentType.indexOf(payment) === -1) {
            return false
          }
        }
        if (this.orderFilters.source && this.orderFilters.source.length > 0) {
          const sourceId = order.order_source_id != null ? order.order_source_id : order.source
          const matchesSource = this.orderFilters.source.some(src => {
            return src === sourceId || Number(src) === Number(sourceId) || String(src) === String(sourceId)
          })
          if (!matchesSource) {
            return false
          }
        }
        if (this.locationFilter.length) {
          const locationId = order.location_id != null
            ? order.location_id
            : (order.production_details && order.production_details.location
              ? (order.production_details.location.true_id || order.production_details.location.id)
              : order.store_id)
          const normalizedLocation = parseInt(locationId, 10)
          const matchesLocation = this.locationFilter.some(id => {
            return parseInt(id, 10) === normalizedLocation || String(id) === String(locationId)
          })
          if (!matchesLocation) {
            return false
          }
        }
        if (this.orderFilters.orderId && String(this.orderFilters.orderId).trim() !== '') {
          if (String(order.id) !== String(this.orderFilters.orderId).trim()) {
            return false
          }
        }
        if (this.orderFilters.orderNumber && this.orderFilters.orderNumber.trim() !== '') {
          if (String(order.number) !== String(this.orderFilters.orderNumber).trim()) {
            return false
          }
        }
        if (this.normalizeOrderTotal(this.orderFilters.orderTotalMin) !== null && Number(order.totals_grandtotal) < Number(this.orderFilters.orderTotalMin)) {
          return false
        }
        if (this.normalizeOrderTotal(this.orderFilters.orderTotalMax) !== null && Number(order.totals_grandtotal) > Number(this.orderFilters.orderTotalMax)) {
          return false
        }
        return true
      },
      getOrderStatus (order) {
        if (!order || order.status == null) {
          return null
        }
        if (typeof order.status === 'object') {
          return order.status.id || order.status.type || null
        }
        return order.status
      },
      getDispatchOrders () {
        this.loading = true
        const dataToSend = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          ...this.buildFilterParams()
        }
        this.apiRequest('/get-dispatch-orders-for-today', 'GET', dataToSend, (response) => {
          this.loading = false
          if (response.status === true) {
            const orders = response.data.orders || []
            this.orders = this.emptyOrdersBuckets()
            this.ordersCount = this.emptyOrdersCount()

            orders.forEach(order => {
              if (!this.orderMatchesClientFilters(order)) {
                return
              }
              const status = this.getOrderStatus(order)
              if (status === 'NEW') {
                this.orders.new.push(order)
                this.ordersCount.new++
              } else if (status === 'PROCESSING') {
                this.orders.processing.push(order)
                this.ordersCount.processing++
              } else if (status === 'PREPARED') {
                this.orders.prepared.push(order)
                this.ordersCount.prepared++
              } else if (status === 'TRANSPORT') {
                this.orders.transport.push(order)
                this.ordersCount.transport++
              } else if (status === 'DELIVERED') {
                this.orders.delivered.push(order)
                this.ordersCount.delivered++
              } else if (status === 'CANCELED') {
                this.orders.canceled.push(order)
                this.ordersCount.canceled++
              }
            })
          } else {
            console.error('Failed to fetch dispatch orders:', response.message)
          }
        })
      },
      goToOrder (orderId) {
        this.$router.push('/orders/view/' + orderId)
      },
      formatDeliveryType (type) {
        if (!type) return ''
        const key = 'deliveryTypes.' + type
        const translated = this.$t(key)
        return translated !== key ? translated : type
      },
      loadSavedFilters () {
        try {
          const savedFilters = JSON.parse(localStorage.getItem('dispatchOrdersKanbanFilters'))
          if (!savedFilters) {
            return
          }
          if (savedFilters.requestFilters && savedFilters.requestFilters[0]) {
            this.requestFilters[0].value = savedFilters.requestFilters[0].value || this.requestFilters[0].value
          }
          if (Array.isArray(savedFilters.locationFilter)) {
            this.locationFilter = savedFilters.locationFilter
          }
          if (savedFilters.orderFilters) {
            this.orderFilters = {
              ...this.orderFilters,
              ...savedFilters.orderFilters
            }
          }
          if (savedFilters.sortOrder) {
            this.sortOrder = parseInt(savedFilters.sortOrder) || 1
          }
        } catch (e) {
          // ignore invalid saved filters
        }
      },
      persistFilters () {
        localStorage.setItem('dispatchOrdersKanbanFilters', JSON.stringify({
          requestFilters: this.requestFilters,
          locationFilter: this.locationFilter,
          orderFilters: this.orderFilters,
          sortOrder: this.sortOrder
        }))
      },
      refreshOrders () {
        this.persistFilters()
        this.getDispatchOrders()
      },
      getLocations () {
        return new Promise((resolve, reject) => {
          const dataToSend = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/get-locations-and-zones', 'GET', dataToSend, (response) => {
            if (response.status === true) {
              this.locations = response.data.locations || []
              if (this.locationFilter.length) {
                this.locationFilter = this.normalizeLocationFilter(this.locationFilter)
              }
              resolve()
            } else {
              reject(response.message)
            }
          })
        })
      },
      openFiltersModal () {
        this.modalRequestFilters = [{
          value: JSON.parse(JSON.stringify(this.requestFilters[0].value))
        }]
        this.modalLocationFilter = this.normalizeLocationFilter(this.locationFilter)
        this.modalSortOrder = parseInt(this.sortOrder) || 1

        let pickupDatetime = null
        if (this.orderFilters.pickupDatetime && this.orderFilters.pickupDatetime.length === 2) {
          pickupDatetime = [
            this.orderFilters.pickupDatetime[0],
            this.adjustEndTime(this.orderFilters.pickupDatetime[1])
          ]
        }

        let placedDatetime = null
        if (this.orderFilters.placedDatetime && this.orderFilters.placedDatetime.length === 2) {
          placedDatetime = [
            this.orderFilters.placedDatetime[0],
            this.adjustEndTime(this.orderFilters.placedDatetime[1])
          ]
        }

        this.modalOrderFilters = {
          pickupDatetime: pickupDatetime,
          placedDatetime: placedDatetime,
          orderId: this.orderFilters.orderId,
          orderNumber: this.orderFilters.orderNumber,
          orderTotalMin: this.orderFilters.orderTotalMin,
          orderTotalMax: this.orderFilters.orderTotalMax,
          operator: JSON.parse(JSON.stringify(this.orderFilters.operator || [])),
          paymentType: JSON.parse(JSON.stringify(this.orderFilters.paymentType || [])),
          deliveryType: JSON.parse(JSON.stringify(this.orderFilters.deliveryType || [])),
          source: JSON.parse(JSON.stringify(this.orderFilters.source || []))
        }
        this.$modal.show('dispatchOrdersFiltersModal')
      },
      applyFilters () {
        this.requestFilters[0].value = JSON.parse(JSON.stringify(this.modalRequestFilters[0].value))
        this.locationFilter = this.normalizeLocationFilter(this.modalLocationFilter)
        this.sortOrder = this.modalSortOrder

        let pickupDatetime = null
        if (this.modalOrderFilters.pickupDatetime && this.modalOrderFilters.pickupDatetime.length === 2) {
          pickupDatetime = [
            this.modalOrderFilters.pickupDatetime[0],
            this.adjustEndTime(this.modalOrderFilters.pickupDatetime[1])
          ]
        }

        let placedDatetime = null
        if (this.modalOrderFilters.placedDatetime && this.modalOrderFilters.placedDatetime.length === 2) {
          placedDatetime = [
            this.modalOrderFilters.placedDatetime[0],
            this.adjustEndTime(this.modalOrderFilters.placedDatetime[1])
          ]
        }

        this.orderFilters = {
          pickupDatetime: pickupDatetime,
          placedDatetime: placedDatetime,
          orderId: this.modalOrderFilters.orderId,
          orderNumber: this.modalOrderFilters.orderNumber,
          orderTotalMin: this.normalizeOrderTotal(this.modalOrderFilters.orderTotalMin),
          orderTotalMax: this.normalizeOrderTotal(this.modalOrderFilters.orderTotalMax),
          operator: JSON.parse(JSON.stringify(this.modalOrderFilters.operator || [])),
          paymentType: JSON.parse(JSON.stringify(this.modalOrderFilters.paymentType || [])),
          deliveryType: JSON.parse(JSON.stringify(this.modalOrderFilters.deliveryType || [])),
          source: JSON.parse(JSON.stringify(this.modalOrderFilters.source || []))
        }

        this.$modal.hide('dispatchOrdersFiltersModal')
        this.refreshOrders()
      },
      resetModalFilters () {
        this.modalRequestFilters[0].value = DEFAULT_STATUSES.slice()
        this.modalLocationFilter = []
        this.modalSortOrder = 1
        this.modalOrderFilters = {
          pickupDatetime: null,
          placedDatetime: null,
          orderId: '',
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: [],
          source: []
        }

        this.requestFilters[0].value = DEFAULT_STATUSES.slice()
        this.locationFilter = []
        this.sortOrder = 1
        this.orderFilters = {
          pickupDatetime: null,
          placedDatetime: null,
          orderId: '',
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: [],
          source: []
        }
        this.refreshOrders()
      },
      resetFilters () {
        this.requestFilters[0].value = DEFAULT_STATUSES.slice()
        this.locationFilter = []
        this.orderFilters = {
          pickupDatetime: null,
          placedDatetime: null,
          orderId: '',
          orderNumber: '',
          orderTotalMin: null,
          orderTotalMax: null,
          operator: [],
          paymentType: [],
          deliveryType: [],
          source: []
        }
        this.sortOrder = 1
        this.refreshOrders()
      },
      removeStatusFilter (index) {
        this.requestFilters[0].value.splice(index, 1)
        this.refreshOrders()
      },
      removeLocationFilter (index) {
        this.locationFilter.splice(index, 1)
        this.refreshOrders()
      },
      removePickupDatetimeFilter () {
        this.orderFilters.pickupDatetime = null
        this.refreshOrders()
      },
      removePlacedDatetimeFilter () {
        this.orderFilters.placedDatetime = null
        this.refreshOrders()
      },
      removeOrderIdFilter () {
        this.orderFilters.orderId = ''
        this.refreshOrders()
      },
      removeOrderNumberFilter () {
        this.orderFilters.orderNumber = ''
        this.refreshOrders()
      },
      removeOrderTotalFilter () {
        this.orderFilters.orderTotalMin = null
        this.orderFilters.orderTotalMax = null
        this.refreshOrders()
      },
      removeOperatorFilter (index) {
        if (index !== undefined) {
          this.orderFilters.operator.splice(index, 1)
        } else {
          this.orderFilters.operator = []
        }
        this.refreshOrders()
      },
      removePaymentTypeFilter (index) {
        if (index !== undefined) {
          this.orderFilters.paymentType.splice(index, 1)
        } else {
          this.orderFilters.paymentType = []
        }
        this.refreshOrders()
      },
      removeDeliveryTypeFilter (index) {
        if (index !== undefined) {
          this.orderFilters.deliveryType.splice(index, 1)
        } else {
          this.orderFilters.deliveryType = []
        }
        this.refreshOrders()
      },
      removeSourceFilter (index) {
        if (index !== undefined) {
          this.orderFilters.source.splice(index, 1)
        } else {
          this.orderFilters.source = []
        }
        this.refreshOrders()
      },
      toggleModalStatusFilter (key) {
        const idx = this.modalRequestFilters[0].value.indexOf(key)
        if (idx === -1) {
          this.modalRequestFilters[0].value.push(key)
        } else {
          this.modalRequestFilters[0].value.splice(idx, 1)
        }
      },
      toggleModalPaymentTypeFilter (paymentType) {
        if (!this.modalOrderFilters.paymentType) {
          this.modalOrderFilters.paymentType = []
        }
        const idx = this.modalOrderFilters.paymentType.indexOf(paymentType)
        if (idx === -1) {
          this.modalOrderFilters.paymentType.push(paymentType)
        } else {
          this.modalOrderFilters.paymentType.splice(idx, 1)
        }
      },
      toggleModalDeliveryTypeFilter (deliveryType) {
        if (!this.modalOrderFilters.deliveryType) {
          this.modalOrderFilters.deliveryType = []
        }
        const idx = this.modalOrderFilters.deliveryType.indexOf(deliveryType)
        if (idx === -1) {
          this.modalOrderFilters.deliveryType.push(deliveryType)
        } else {
          this.modalOrderFilters.deliveryType.splice(idx, 1)
        }
      },
      toggleModalSourceFilter (src) {
        if (!this.modalOrderFilters.source) {
          this.modalOrderFilters.source = []
        }
        const idx = this.modalOrderFilters.source.indexOf(src)
        if (idx === -1) {
          this.modalOrderFilters.source.push(src)
        } else {
          this.modalOrderFilters.source.splice(idx, 1)
        }
      },
      toggleFiltersCollapse () {
        this.showFiltersCollapsed = !this.showFiltersCollapsed
      },
      getLocationFilterValue (loc) {
        if (loc.true_id != null && loc.true_id !== '') {
          return parseInt(loc.true_id, 10)
        }
        return loc.id
      },
      getLocationName (locationId) {
        const location = this.locations.find(loc => loc.true_id === locationId || loc.id === locationId)
        return location ? location.name : locationId
      },
      normalizeLocationFilter (locationFilter) {
        if (!locationFilter || !Array.isArray(locationFilter) || locationFilter.length === 0) {
          return []
        }
        const normalized = []
        for (const value of locationFilter) {
          const numValue = typeof value === 'string' ? parseInt(value, 10) : value
          const location = this.locations.find(loc => {
            if (loc.true_id === numValue || loc.true_id === value) return true
            if (loc.id === numValue || loc.id === value) return true
            if (typeof value === 'string') {
              return String(loc.true_id) === value || String(loc.id) === value
            }
            return false
          })
          if (location) {
            const filterValue = this.getLocationFilterValue(location)
            if (!normalized.includes(filterValue)) {
              normalized.push(filterValue)
            }
          }
        }
        return normalized
      },
      getOperatorName (operatorId) {
        const operator = this.operatorOptions.find(op => op.id === operatorId)
        return operator ? operator.label : operatorId
      },
      formatDateRange (dateRange) {
        if (!dateRange || dateRange.length !== 2) return ''
        return `${dateRange[0]} - ${dateRange[1]}`
      },
      normalizeOrderTotal (value) {
        if (value === null || value === undefined || value === '') {
          return null
        }
        const num = Number(value)
        // el-input-number turns empty fields into 0; do not treat that as a filter
        if (isNaN(num) || num === 0) {
          return null
        }
        return num
      },
      adjustEndTime (datetime) {
        if (datetime && datetime.endsWith('00:00:00')) {
          return datetime.replace('00:00:00', '23:59:59')
        }
        return datetime
      },
      adjustDatetimeRange (filterType) {
        if (this.modalOrderFilters[filterType] && this.modalOrderFilters[filterType].length === 2) {
          this.modalOrderFilters[filterType] = [
            this.modalOrderFilters[filterType][0],
            this.adjustEndTime(this.modalOrderFilters[filterType][1])
          ]
        }
      },
      formatLabelFirstLetter (translationKey) {
        try {
          const label = this.$t(translationKey)
          if (!label || typeof label !== 'string') {
            const fallback = translationKey.split('.').pop()
            return fallback ? fallback.toLowerCase().split(' ').map(word => {
              return word.charAt(0).toUpperCase() + word.slice(1)
            }).join(' ') : translationKey
          }
          return label.toLowerCase().split(' ').map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1)
          }).join(' ')
        } catch (e) {
          const key = translationKey.split('.').pop()
          return key ? key.toLowerCase().split(' ').map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1)
          }).join(' ') : translationKey
        }
      },
      getPosUsers () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/pos/all/users', 'GET', data, (response) => {
          if (response.status && response.data && response.data.pos_user) {
            this.operatorOptions = response.data.pos_user.map(user => ({
              id: user.id,
              label: `${user.firstname || ''} ${user.lastname || ''}`.trim() || `User ${user.id}`
            }))
          }
        })
      }
    }
  }
</script>

<style scoped>
  .dispatch-orders-page {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 70px);
    overflow: hidden;
    background: #F4F6FF;
  }
  .dispatch-orders-filters {
    flex: 0 0 auto;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 8px 10px;
    background: #fff;
    border-bottom: 1px solid #E6EFFB;
  }
  .dispatch-orders-filters .filterLocation {
    flex: 0 0 auto;
    width: auto;
  }
  .dispatch-orders-filters .filter-btn {
    width: auto !important;
    min-width: 0 !important;
    height: auto !important;
    margin: 0 !important;
  }
  .dispatch-orders-filters .filter-btn img {
    display: block;
  }
  .dispatch-orders-filters-body {
    flex: 1;
    min-width: 0;
    font-size: 13px;
    font-weight: 500;
    color: #25396F;
  }
  .filters-header {
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 36px;
  }
  .filters-label {
    color: #25396F;
  }
  .no-filters-label {
    display: inline-flex;
    align-items: center;
    min-height: 36px;
    color: #7C8DB5;
    font-weight: 400;
  }
  .filters-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 4px;
  }
  .filter-selection {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 8px;
    background: #F4F6FF;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #25396F;
  }
  .filter-selection a {
    display: inline-flex;
    line-height: 1;
  }
  .reset-filters-link {
    margin-left: auto;
    color: #409eff;
    text-decoration: none;
    font-weight: 400;
    font-size: 12px;
  }
  .collapse-toggle-btn {
    background: #409eff;
    border: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    color: white;
    flex-shrink: 0;
  }
  .canvaOrders {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    padding: 10px;
    background: #F4F6FF;
    overflow-x: auto;
    overflow-y: auto;
  }
</style>
<style>
  .order-top {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #D9E6F8;
    padding: 0 10px;
  }
  .col-order {
    flex: 1;
    margin: 5px;
    padding: 0px;
    border-radius: 4px;
    min-width: 381px;
    max-width: 381px;
  }
  .col-order > p {
    display: inline-flex;
    text-transform: uppercase;
  }
  .col-order > p > span {
    width: 37px;
    box-shadow: 0 1px 10px -4px rgba(0, 0, 0, 0.1);
    background: #fff;
    margin-left: 5px;
    border-radius: 10px;
    text-align: center;
  }
  .order-card {
    background: #fff;
    margin-bottom: 10px;
    padding: 12px 0px;
    border: 1px solid #D9E6F8;
    border-radius: 16px;
  }
  .ord-client {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    padding: 10px 20px 10px 20px;
    margin-top: 10px;
    font-size: 14px;
    background: #fff;
    border-radius: 18px;
    position: relative;
  }
  .ord-client .client {
    margin: 0px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
  }
  .ord-client .address span.zone {
      display: block;
  }
  .col-order.new > p::before {
    content: '• ';
    color: #68B3C8;
    font-size: 48px;
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }

  .orderDate span {
    font-size: 13px;
    color: #25396F;
  }
  .örderId p {
    background: #F4F6FF;
    padding: 3px 20px;
    border-radius: 7px;
    font-weight: 500;
    font-size: 14px;
    cursor: pointer;
    border: 1px solid transparent;
  }
  .örderId p:hover {
    border: 1px solid #674BD2;
  }
  .col-order.processing > p::before {
    content: '• ';
    color: #F39E1A;
    font-size: 48px;
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }

  .col-order.prepared > p::before {
    content: '• ';
    color: #674BD2;
    font-size: 48px;
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }

  .col-order.transport > p::before {
    content: '• ';
    color: #66615B;
    font-size: 48px;
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }

  .col-order.delivered > p::before {
    content: '• ';
    color: #7AC29A;
    font-size: 48px;
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }

  .col-order.canceled > p::before {
    content: '• ';
    color: #EB5E28;
    font-size: 48px;
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  .order-card .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
  }
  .order-card .footer .method {
    color: #FF0D19;
    background: #FFF2F3;
    padding: 7px 30px;
    border-radius: 8px;
  }
</style>
<style lang="scss">
  .vm--container.dispatch-filters-modal {
    max-width: 100%;
    overflow-x: hidden;
  }

  .vm--container.dispatch-filters-modal .filters-grid {
    display: grid;
    grid-template-columns: 60% 40%;
    gap: 20px;
    overflow-x: hidden;
    width: 100%;
    box-sizing: border-box;
  }

  .vm--container.dispatch-filters-modal .modal-column-left,
  .vm--container.dispatch-filters-modal .modal-column-right {
    max-height: 600px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 15px;
    box-sizing: border-box;
  }

  .vm--container.dispatch-filters-modal .card {
    margin-bottom: 0 !important;
  }

  .vm--container.dispatch-filters-modal .card-content {
    padding: 10px !important;
    overflow-x: hidden;
  }

  .vm--container.dispatch-filters-modal .slim-header {
    padding: 6px 10px !important;
    border-bottom: 1px solid #e6e6e6;
  }

  .vm--container.dispatch-filters-modal .slim-header h4 {
    margin: 0;
  }

  .vm--container.dispatch-filters-modal .slim-body {
    padding: 8px !important;
    overflow-x: hidden;
  }

  .vm--container.dispatch-filters-modal .slim-footer {
    text-align: right;
    margin-top: 8px;
    border-top: 1px solid #eee;
    padding-top: 6px;
    padding-bottom: 0 !important;
    padding-left: 15px !important;
    padding-right: 0 !important;
  }

  .vm--container.dispatch-filters-modal .filter-section {
    margin-bottom: 14px;
  }

  .vm--container.dispatch-filters-modal .filter-section h6 {
    margin-bottom: 8px;
    font-weight: 500;
  }

  .vm--container.dispatch-filters-modal .button-group-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter {
    min-width: 120px;
    padding: 10px 23px;
    border-radius: 50px;
    height: 40px;
    line-height: 19px;
    font-size: 14px;
    font-weight: 400;
    border-color: white;
    white-space: nowrap;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    text-transform: none !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.btn-default {
    background: #f0f0f0 !important;
    color: #666 !important;
    border: 1px solid #ddd !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.current {
    color: white !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.current.NEW {
    background-color: #0097FC !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.current.PROCESSING {
    background-color: #F3BB45 !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.current.PREPARED {
    background-color: #5e35b1 !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.current.TRANSPORT {
    background-color: #0f566a !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.current.DELIVERED {
    background-color: #7AC29A !important;
  }

  .vm--container.dispatch-filters-modal .status-filter-buttons .btn-status-filter.current.CANCELED {
    background-color: #EB5E28 !important;
  }

  .vm--container.dispatch-filters-modal .range-row {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  @media (max-width: 768px) {
    .vm--container.dispatch-filters-modal .filters-grid {
      grid-template-columns: 1fr;
    }

    .vm--container.dispatch-filters-modal .modal-column-left,
    .vm--container.dispatch-filters-modal .modal-column-right {
      max-height: none;
      padding-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Dispatch/DispatchOrders.vue